import * as React from 'react';

export const PostnordServiceIcon: React.FunctionComponent = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="8" cy="8" r="6" fill="#01A0D7" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.31548 6.46737C5.31548 6.46737 5.65746 6 6.40754 6C7.50415 6 8.12427 6.85039 8.12199 7.91509C8.12199 8.95242 7.41296 9.80965 6.3095 9.80965C5.63238 9.80965 5.31548 9.47223 5.31548 9.47223V10.7307H4V6.11627H5.31548V6.46737ZM5.27672 7.91509C5.27672 8.33686 5.57311 8.6492 6.00628 8.6492C6.44629 8.6492 6.729 8.33686 6.729 7.91509C6.729 7.46823 6.43945 7.16273 6.00628 7.16273C5.56627 7.16273 5.27672 7.46595 5.27672 7.91509ZM9.63123 6.46737C9.63123 6.46737 9.90937 6 10.6777 6C11.5304 6 12 6.51297 12 7.50015V9.70022H10.6708V7.96752C10.6708 7.53891 10.6116 7.20149 10.2058 7.20149C9.79994 7.20149 9.63123 7.40896 9.63123 7.86265V9.70022H8.31575V6.11627H9.63123V6.46737Z"
        fill="white"
      />
    </svg>
  );
};
